import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import "./style.css";

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 576,
      settings: {
        arrows: false,
        slidesToShow: 1,
      },
    },
  ],
};

const Sdata = [
  {
    id: 1,
    comment: `“He did great. He had in consideration every requirement and detail. He delivered previews while he was working on the project and constant updates. Will work with him again.”`,
    name: "mhannun",
  },
  {
    id: 2,
    comment: `“super good at his job, recommended 500%%”`,
    name: "lasalsadelbaile",
  },
  {
    id: 3,
    comment: `“Excellent job done above requirements. Nothing but praise for him. Best front end developer I have ever worked with! I can only say that I was fortunate to work with him. He followed all the specifications, asked where unclear, made changes without limit and never complained about anything. I will work with him after this for sure. I strongly recommend him to others looking for a diligent gig.”`,
    name: "safash",
  },
  {
    id: 4,
    comment: `“Ashir was really responsive and ready to improve of the the smallest details. I will work with him again. Thanks a lot :)”`,
    name: "maxencedubois",
  },
  {
    id: 5,
    comment: `“Ashir did a fantastic job. He not only gave a highest quality deliverable but also delivered in promised time. The best thing was that he kept sharing the progress at every step and kept my team updated throughout the process. 10/10 will recommend.”`,
    name: "aniltaneja30",
  },
  {
    id: 6,
    comment: `“Seller was extremely pleasant to work with, and made visible effort to assist with requirements. Go for it!”`,
    name: "talkessler480",
  },

];

function Testimonial() {
  return (
    <div className="Testimonial py-5 border-bottom">
      <div className="container py-3">
        <div className="Testimonial__headings pb-4 fs-5">
          <span
            className="Testimonial__headings--small text-uppercase"
            data-aos={"fade-out"}
            data-aos-duration={1500}
            data-aos-offset={10}
          >
            _Testimonial
          </span>
          <h1
            className="Testimonial__headings--h1 mt-3"
            data-aos={"fade-out"}
            data-aos-duration={1500}
            data-aos-offset={8}
          >
            What Clients Say!
          </h1>
          <h4 className="Testimonial__headings__detail my-3">
            Testimonials from past clients showcase my
            exceptional work and collaborative nature. Their positive
            experiences and recommendations speak to my commitment to delivering
            outstanding results and providing a great customer experience.
          </h4>
        </div>
        <Slider
          {...settings}
          className="Testimonial__slider text-center d-flex align-items-center justify-content-center"
        >
          {Sdata.map((item) => (
            <div
              className="Testimonial__slider__content px-3"
              key={item.id}
              data-aos={"fade-out"}
              data-aos-duration={1500}
              data-aos-offset={8}
            >
              <h4 className="Testimonial__slider__content__comment">
                {item.comment}
              </h4>
              <small className="Testimonial__slider__content__name">
                {item.name}
              </small>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default Testimonial;
